import actions from './actions'

export default function TabletErrorLogsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TABLETERRORLOG:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TABLETERRORLOG:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TABLETERRORLOG:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TABLETERRORLOG:
      return {
        ...state,
        editing: { TabletErrorLogID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TABLETERRORLOG_RECIEVED ||
      actions.UPDATE_TABLETERRORLOG_RECIEVED ||
      actions.DELETE_TABLETERRORLOG_RECIEVED:
      return {
        ...state,
        editing: { TabletErrorLogID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
